/**
 * @generated SignedSource<<27364d8aa38b12e26cb7464ebb035e6b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useEducationLevelCriteria_query$data = {
  readonly currentUser: {
    readonly educationLevelCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly educationLevelId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useEducationLevelCriteria_query";
};
export type useEducationLevelCriteria_query$key = {
  readonly " $data"?: useEducationLevelCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEducationLevelCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useEducationLevelCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "EducationLevelCriterionConnection",
          "kind": "LinkedField",
          "name": "educationLevelCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EducationLevelCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "educationLevelId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "educationLevelCriteria(orderBy:[\"EDUCATION_LEVEL_BY_EDUCATION_LEVEL_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "7d819cb3102d11e43ff7a3e73ed4d8ae";

export default node;
